import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    gamesLimit = 14

    connect() {
        this.updateState()
    }

    checkboxChanged() {
        this.updateState()
    }

    updateState() {
        const checkboxes = Array.from(this.element.querySelectorAll("input[type=checkbox]"))
        const checked = checkboxes.filter(cb => cb.checked)
        const isLimitReached = checked.length >= this.gamesLimit

        checkboxes.forEach(cb => {
            const label = this.element.querySelector(`label[for="${cb.id}"]`)
            if (isLimitReached) {
                label.classList.add("not-peer-checked:opacity-40", "not-peer-checked:pointer-events-none")
            } else {
                label.classList.remove("not-peer-checked:opacity-40", "not-peer-checked:pointer-events-none")
            }
        })
    }
}
